
import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/context/AuthContext";

export const useProductCopilotTour = () => {
  const { user } = useAuth();
  const [showTour, setShowTour] = useState(false);

  // Check if user should see the tour
  useEffect(() => {
    const checkTourStatus = async () => {
      if (!user) return;
      
      try {
        const { data, error } = await supabase
          .from('profiles')
          .select('has_seen_copilot_tour')
          .eq('id', user.id)
          .single();
        
        if (!error && !data?.has_seen_copilot_tour) {
          setShowTour(true);
        }
      } catch (error) {
        console.error('Error checking tour status:', error);
      }
    };

    checkTourStatus();
  }, [user]);

  return {
    showTour,
    setShowTour
  };
};
